import { render, staticRenderFns } from "./StockControlMobile.vue?vue&type=template&id=582bb991&scoped=true&"
import script from "./StockControlMobile.vue?vue&type=script&lang=js&"
export * from "./StockControlMobile.vue?vue&type=script&lang=js&"
import style0 from "./StockControlMobile.vue?vue&type=style&index=0&id=582bb991&scoped=true&lang=css&"
import style1 from "./StockControlMobile.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582bb991",
  null
  
)

export default component.exports
import {QSeparator,QList,QItem,QItemSection,QItemLabel,QBtn,QSpace,QInnerLoading,QSpinnerGears,QField,QCheckbox} from 'quasar'
component.options.components = Object.assign({QSeparator,QList,QItem,QItemSection,QItemLabel,QBtn,QSpace,QInnerLoading,QSpinnerGears,QField,QCheckbox}, component.options.components || {})
